import { get } from "./request";

const parseDropdownOptions = (res) => {
  if (!res) {
    return [];
  }

  const items = Array.isArray(res) ? res : res.recordset || [];

  return items
    .map((item) => {
      const text =
        typeof item === "string"
          ? item
          : item.name || item.Name || item.Title || item.value;

      return text ? { id: text, text } : null;
    })
    .filter(Boolean);
};

export const enrollmentApi = {
  getStates: async ({ localeId }) => {
    const res = await get(
      `/api/enrollment/states?country=china&localeId=${localeId}`
    );
    return parseDropdownOptions(res);
  },

  getCities: async ({ localeId, selectedProvince }) => {
    if (!selectedProvince) {
      return [];
    }

    const res = await get(
      `/api/enrollment/cities?country=china&state=${encodeURIComponent(
        selectedProvince
      )}&localeId=${localeId}`
    );
    return parseDropdownOptions(res);
  },

  getCounties: async ({ localeId, selectedProvince, selectedCity }) => {
    if (!selectedCity) {
      return [];
    }

    const res = await get(
      `/api/enrollment/counties?country=china&state=${encodeURIComponent(
        selectedProvince
      )}&city=${encodeURIComponent(selectedCity)}&localeId=${localeId}`
    );
    return parseDropdownOptions(res);
  },
};
